/* guard to check if the password of a user has been reset by an administrator
* and needs to be changed by the user
* */

import {inject} from "@angular/core";
import {CanActivateFn, Router} from "@angular/router";
import {ApiService} from "../../services/api.service";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {distinctUntilChanged, map, of, take} from "rxjs";
import {UserService} from "../../services/user.service";

export const passwordUpdateRequiredGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  const router = inject(Router);

  return of(userService.user()?.require_password_update).pipe(
    take(1),
    map(passwordUpdateRequired => {
      if (passwordUpdateRequired) {
        return router.createUrlTree(['/reset-password'])
      }
      return true
    })
  )
};
